import _asyncToGenerator from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectWithoutProperties from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["text", "inheritedStyles", "className"];
var __jsx = React.createElement;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import _regeneratorRuntime from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import styles from './EmergencyBanner.style';
import parse from 'html-react-parser';
import { getParaTextCount } from './helper';
var StyleSection = styled.section.withConfig({
  componentId: "sc-59lghw-0"
})(["", ";"], styles);
var EmergencyBanner = function EmergencyBanner(_ref) {
  var text = _ref.text,
    inheritedStyles = _ref.inheritedStyles,
    className = _ref.className,
    others = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(''),
    paraParsedDom = _useState[0],
    setParaParsedDom = _useState[1];
  var _useState2 = useState(''),
    paraDOM = _useState2[0],
    setParaDOM = _useState2[1];
  var _useState3 = useState(false),
    expand = _useState3[0],
    setExpand = _useState3[1];
  var _useState4 = useState(false),
    displayShowAnchor = _useState4[0],
    setDisplayShowAnchor = _useState4[1];
  var _useState5 = useState(),
    converter = _useState5[0],
    setConverter = _useState5[1];
  var _useState6 = useState(),
    textTest = _useState6[0],
    setTextTest = _useState6[1];
  var divRef = useRef(null);
  var importConverter = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var Showdown, CONVERTER;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return import('showdown');
            case 2:
              Showdown = _context.sent;
              CONVERTER = new Showdown.Converter();
              setConverter(CONVERTER);
              return _context.abrupt("return", CONVERTER);
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function importConverter() {
      return _ref2.apply(this, arguments);
    };
  }();
  var getConverter = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!converter) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", converter);
            case 2:
              _context2.next = 4;
              return importConverter();
            case 4:
              return _context2.abrupt("return", _context2.sent);
            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function getConverter() {
      return _ref3.apply(this, arguments);
    };
  }();
  var ReadMore = function ReadMore() {
    var handleShowMore = function handleShowMore() {
      setExpand(true);
      var bannerDiv = divRef.current;
      bannerDiv.style.cssText += 'height: unset;';
      var formattedText = converter.makeHtml(text.replace(/\\/g, ''));
      setParaParsedDom(formattedText);
    };
    var handleShowLess = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var converterString, bannerDiv, formattedText;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getConverter();
              case 2:
                converterString = _context3.sent;
                setExpand(false);
                bannerDiv = divRef.current;
                bannerDiv.style.cssText += 'height: 78px;';
                formattedText = converterString.makeHtml(text.replace(/\\/g, ''));
                _context3.t0 = setParaParsedDom;
                _context3.next = 10;
                return getParaTextCount(window.innerWidth, formattedText);
              case 10:
                _context3.t1 = _context3.sent;
                (0, _context3.t0)(_context3.t1);
              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function handleShowLess() {
        return _ref4.apply(this, arguments);
      };
    }();
    var handleKeyDown = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
        var keyCode;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                keyCode = e.keyCode || e.which;
                if (!(keyCode === 13 || keyCode === 32)) {
                  _context4.next = 12;
                  break;
                }
                if (!expand) {
                  _context4.next = 9;
                  break;
                }
                _context4.next = 5;
                return handleShowLess();
              case 5:
                e.target.focus();
                e.preventDefault();
                _context4.next = 12;
                break;
              case 9:
                handleShowMore();
                e.target.focus();
                e.preventDefault();
              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return function handleKeyDown(_x) {
        return _ref5.apply(this, arguments);
      };
    }();
    return __jsx("a", {
      tabIndex: "0",
      title: expand ? 'Read Less' : 'Read More',
      className: "read-more",
      onClick: expand ? handleShowLess : handleShowMore,
      onKeyDown: handleKeyDown
    }, expand ? 'Read Less' : 'Read More');
  };
  useEffect(function () {
    if (paraParsedDom) {
      setParaDOM(displayShowAnchor ? paraParsedDom : paraParsedDom.slice(0, -4) + "".concat(expand ? '' : '...', " <a tabindex=\"0\" title=").concat(expand ? 'Read Less' : 'Read More', " id=\"read-more\">").concat(expand ? 'Read Less' : 'Read More', "</a></p>"));
    }
  }, [paraParsedDom, displayShowAnchor, expand]);
  var setTextInBanner = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var converterString, formattedText, initailTruncateText, updateWindowDimensions;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return getConverter();
            case 2:
              converterString = _context6.sent;
              formattedText = converterString.makeHtml(text.replace(/\\/g, ''));
              _context6.next = 6;
              return getParaTextCount(window.innerWidth, formattedText);
            case 6:
              initailTruncateText = _context6.sent;
              setParaParsedDom(initailTruncateText);
              setDisplayShowAnchor(initailTruncateText === formattedText);
              updateWindowDimensions = /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  var newWidth, truncatedText;
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          newWidth = window.innerWidth;
                          _context5.next = 3;
                          return getParaTextCount(newWidth, formattedText);
                        case 3:
                          truncatedText = _context5.sent;
                          setDisplayShowAnchor(truncatedText === formattedText);
                          setParaParsedDom(truncatedText);
                          setExpand(false);
                        case 7:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));
                return function updateWindowDimensions() {
                  return _ref7.apply(this, arguments);
                };
              }();
              window.addEventListener('resize', updateWindowDimensions);
              return _context6.abrupt("return", function () {
                return window.removeEventListener('resize', updateWindowDimensions);
              });
            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return function setTextInBanner() {
      return _ref6.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (text) {
      setTextInBanner();
    }
  }, [text]);
  var replace = function replace(domNode) {
    if (domNode.name === 'a') {
      if (domNode.children.length > 0) {
        var _iterator = _createForOfIteratorHelper(domNode.children),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var element = _step.value;
            if (element.data) {
              domNode.attribs.title = element.data;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
    if (domNode && domNode.attribs && Object.keys(domNode.attribs).length > 0 && domNode.attribs.id === 'read-more') {
      return __jsx(ReadMore, null);
    }
  };
  useEffect(function () {
    if (!paraDOM) {
      return;
    }
    var data = parse(paraDOM, {
      replace: replace
    });
    setTextTest(data);
  }, [paraDOM]);
  return __jsx(StyleSection, {
    className: "nva-emergency-banner ".concat(className)
  }, __jsx("div", {
    ref: divRef,
    id: "emergency-banner",
    className: "nva-emergency-banner__div banner-div"
  }, __jsx("div", {
    className: "nva-emergency-banner__text banner-text"
  }, textTest)));
};
EmergencyBanner.defaultProps = {
  text: '',
  inheritedStyles: ''
};
export default styled(EmergencyBanner).withConfig({
  componentId: "sc-59lghw-1"
})(["", ";"], styles);
export { EmergencyBanner as EmergencyBannerVanilla };